import React from "react";

class ScrollTo extends React.Component {
  componentDidMount() {
    window.scrollTo(0, this.props.position)
  }

  render() {
    return <span />
  }
}

export default ScrollTo;